import { MdOutlineWarningAmber } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const DeactivebadgeShow = ({ cutButton, setCutbutton }) => {
  if (!cutButton) return null;

  return (
    <div
      style={{
        width: "100%",
        background: "#fff4e5",
        borderBottom: "1px solid #f5c27a",
        padding: "12px 18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "15px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flex: 1,
        }}
      >
        <div
          style={{
            minWidth: "40px",
            height: "40px",
            borderRadius: "50%",
            background: "#ffe0b2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MdOutlineWarningAmber
            style={{
              fontSize: "22px",
              color: "#e65100",
            }}
          />
        </div>

        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#5d4037",
            lineHeight: "1.6",
            fontWeight: "500",
          }}
        >
          Your profile has been temporarily suspended. For more details, please
          check your email from{" "}
          <a
            href="mailto:hello@workcroft.com"
            style={{
              color: "#1565c0",
              fontWeight: "700",
              textDecoration: "none",
            }}
          >
            hello@workcroft.com
          </a>
        </p>
      </div>

      <button
        onClick={() => setCutbutton(false)}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px",
        }}
      >
        <IoClose
          style={{
            fontSize: "22px",
            color: "#5d4037",
          }}
        />
      </button>
    </div>
  );
};

export default DeactivebadgeShow;
